import { useToolbarPosition } from "@pathwright/ux/src/components/augmentation/AugmentationPositionedToolbar"
import { AugmentationToolbarOption } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { usePathwrightIntercomLauncher } from "../useIntercomLauncher"

function useIntercomAugmentationToolbar(): AugmentationToolbarOption | null {
  const intercomLayoutOptions = useToolbarPosition(
    {
      bottom: {
        horizontal_padding: 0, // Horizontal padding
        vertical_padding: 70 // Vertical padding, to not hide the toolbar =/
      },
      side: {
        horizontal_padding: 70, // Horizontal padding, to not hide the toolbar =/
        vertical_padding: 0 // Vertical padding
      }
    },
    true /* allowOverlay */
  )
  const {
    onToggle: onToggleIntercom,
    open: isIntercomOpen,
    usingPathwrightIntercom
  } = usePathwrightIntercomLauncher(intercomLayoutOptions)

  // Providing Pathwright's custom Intercom launcher.
  return usingPathwrightIntercom
    ? {
        key: "intercom",
        icon: "question-mark-fill",
        label: "Pathwright Help",
        onClick: onToggleIntercom,
        isSelected: isIntercomOpen
      }
    : null
}

export default useIntercomAugmentationToolbar
